import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { getValue } from "@utils/lodash";
import "./LeftNavigation.scss";
import { useLocation } from "react-router-dom";

export default function LeftNavigation() {
	const location = useLocation();
	const [navigationMenu] = useState([
		// {
		// 	title: "DashBoard",
		// 	icon: "/images/navigation-icons/dashboard.svg",
		// 	link: "/dashboard",
		// 	parentLink: "/dashboard",
		// },

		{
			title: "Checkpoint",
			icon: "/images/navigation-icons/checkpoint.svg",
			parentLink: "/checkpoint",
			link:"/checkpoint"
		},
		{
			title: "Reports",
			icon: "/images/navigation-icons/support.svg",
			link: "/reports",
			parentLink: "/reports",
			name: "reports",
			subMenu: [
			  {
				title: "Accounts",
				link: "/reports/account",
				name: "reports_account",
			  },
			  {
				title: "Location",
				link: "/reports/location",
				name: "reports_location",
			  },
			  {
				title: "Score History",
				link: "/reports/vendor-history",
				name: "reports_vendor_history",
			  },
			  {
				title: "Compliance Scorecard",
				link: "/reports/compliance-scorecard",
				name: "reports_compliance_scorecard",
			  },
			  {
				title: "Linewise Item",
				link: "/reports/vendor-compliance",
				name: "reports_vendor_compliance",
			  },
			],
		  },
		{
			title: "Support",
			icon: "/images/navigation-icons/support.svg",
			link: "/support",
			parentLink: "/support",
			name: "support",
			subMenu: [
			  {
				title: "Open",
				link: "/support/open",
				name: "support_open",
			  },
			  {
				title: "In Progress",
				link: "/support/inprogress",
				name: "support_in_progress",
			  },
			  {
				title: "Closed",
				link: "/support/closed",
				name: "support_closed",
			  },
			],
		  },
		{
			title: "Vendor Org Profile",
			icon: "/images/navigation-icons/audit.svg",
			parentLink: "/vendor-profile",
			link:"/vendor-profile"
		},

		


	]);

	useEffect(() => {
		// console.log(location);
	}, []);

	return (
		<nav className="navigation-menu">
			<ul>
				{navigationMenu.map((menuObj, index) => {
					return (
						<>
							<li
								className={`navigation-menu__menu-item ${
									!getValue(menuObj,`subMenu`,'') ? "navigation-menu__no-sub-menu-item" : ""
								}
								${
									!getValue(menuObj,`subMenu`,'') &&
									window.location.pathname ===
										getValue(menuObj, `parentLink`, "")
										? "active"
										: ""
								}
							`}
							>
								<label
									className={`d-flex w-100 align-items-flex-start ${
										getValue(menuObj,`subMenu`,'')? "cursor-pointer" : ""
									}`}
									htmlFor={`nav-menu-${index}`}
								>
									<div className="navigation-menu__menu-icon">
										<img
											src={menuObj.icon}
											className="material-symbols-outlined img-fluid"
										/>
									</div>
									<div className="d-flex align-items-flex-start justify-content-between navigation-menu__menu-elements">
										{getValue(menuObj,`subMenu`,'') ? (
											<a className="nav-link">{menuObj.title}</a>
										) : (
											<NavLink
												to={getValue(menuObj, `link`, "")}
												className="nav-link w-100"
											>
												<a>{menuObj.title}</a>
											</NavLink>
										)}

										{getValue(menuObj,`subMenu`,'') && (
											<img
												src="/images/arrow-down.svg"
												className="img-fluid dropdown-arrow cursor-pointer"
											/>
										)}
									</div>
								</label>
								{getValue(menuObj,`subMenu`,'') && (
									<input
										type="checkbox"
										id={`nav-menu-${index}`}
										name="navigation-menu"
										className="left-navigation__checkbox d-none"
										defaultChecked={location.pathname.includes(
											menuObj.parentLink
										)}
									/>
								)}
								{getValue(menuObj,`subMenu`,'') && (
									<ul className={`navigation-menu__sub-menu`}>
										{getValue(menuObj,`subMenu`,'')?.map((subMenuObj:any, index:number) => {
											return (
												<NavLink
													to={getValue(subMenuObj, `link`, "")}
													key={`navigation-menu__sub-menu-${index}`}
												>
													<li
														className={`${index} navigation-menu__sub-menu-link
                            								${
																							window.location.pathname ===
																								getValue(
																									subMenuObj,
																									`link`,
																									""
																								) && "active"
																						}`}
													>
														<span>{subMenuObj.title}</span>
													</li>
												</NavLink>
											);
										})}
									</ul>
								)}
							</li>
						</>
					);
				})}
			</ul>
		</nav>
	);
}
